export default {
    topics: [
        {
            title: ' Entity (Class) ',
            href: 'c-Entity.html',
            attributes: { 'data-id': 'c-Entity' },
            menu: { hasChildren: false },
            tocID: 'c-Entity-d66e6741',
            next: 'c-Entity-d66e6741',
        },
        {
            title: ' EntityCollection (Class) ',
            href: 'c-EntityCollection.html',
            attributes: { 'data-id': 'c-EntityCollection' },
            menu: { hasChildren: false },
            tocID: 'c-EntityCollection-d66e6757',
            next: 'c-EntityCollection-d66e6757',
        },
    ],
};

